import { Action } from 'redux'
import { ITransferFormValues } from '../../../containers/BookingCalendar/TransferReservationModal/TransferReservationForm'
import { EventActions } from '../../../reducers/bookingCalendar/actionNames'
import { IEvent } from '../../../models/Event'
import { createFormActions } from '../../form'

const requestTransferReservation = createFormActions<ITransferFormValues>(
  EventActions.RequestTransferReservation,
)

const reservationWasTransfered = (
  event: IEvent,
  roomId = undefined,
  lastRoomId = undefined,
): IReservationWasTransfered => ({
  event,
  lastRoomId,
  roomId,
  type: EventActions.ReservationWasTransfered,
})

export interface IReservationWasTransfered
  extends Action<EventActions.ReservationWasTransfered> {
  event: IEvent
  lastRoomId?: string
  roomId?: string
}

export { reservationWasTransfered }
export default requestTransferReservation
